import { render } from "./MyVacationYear.vue?vue&type=template&id=133e39fa"
import script from "./MyVacationYear.vue?vue&type=script&lang=js"
export * from "./MyVacationYear.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/halisclock/releases/44/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__